module.exports = __webpack_public_path__ + "556e491501defd220fe6d3a85a016219.svg";